export const ActionType = Object.freeze({
  1: "PrescribeMedication",
  2: "ProcessPayment",
  3: "SendReferralLetter",
  4: "BookAppointment",
  5: "RecordVitals",
  6: "Vaccinations",
  7: "General",
  8: "Document",
  9: "Signature",
  13: "ImageDocument",
});
